<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Discount
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<!-- Code -->
								<div class="col-md-6">
									<label for="inputCode" class="col-form-label">Code <span class="text-danger">*</span></label>
									<input type="text" v-model="discountRequest.code" @blur="validationRule()" class="form-control" id="inputCode">
									<small class="text-danger">{{validationData.code}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputName" class="col-form-label">Name <span class="text-danger">*</span></label>
									<input type="text" v-model="discountRequest.name" @blur="validationRule()" class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputRole" class="col-form-label">Category <span class="text-danger">*</span></label>
									<select v-model="discountRequest.category" @blur="validationRule()" class="form-control" id="inputRole">
										<option value="">Select Category</option>
										<option value="scholar">Scholar Discount</option>
										<option value="bod">BOD Discount</option>
										<option value="normal">Normal Discount</option>
										<option value="special">Special Case</option>
									</select>
									<small class="text-danger">{{validationData.category}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputRole" class="col-form-label">Discount Type <span class="text-danger">*</span></label>
									<select v-model="discountRequest.discount_type" @blur="validationRule()" class="form-control" id="inputRole">
										<option value="">Select Discount Type</option>
										<option value="percentage">Percentage (%)</option>
										<option value="fixed">Fixed Amount</option>
									</select>
									<small class="text-danger">{{validationData.discount_type}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputValue" class="col-form-label">Value <span class="text-danger">*</span></label>
									<input type="number" v-model="discountRequest.discount_value" @blur="validationRule()" class="form-control" id="inputValue">
									<small class="text-danger">{{validationData.discount_value}}</small>
								</div>
								<div class="col-md-6 pt-4">
									<div class="form-check" style="margin-top: 20px;">
										<input class="form-check-input" type="checkbox" id="activeCheckbox" v-model="discountRequest.active">
										<label class="form-check-label" for="activeCheckbox">
											Active
										</label>
									</div>
								</div>
							</div>
							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'accountCreate',
		metaInfo: {
            title: "Account Create",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				discountRequest: {
					code: "",
					name: "",
					category: "",
					discount_type: "",
					discount_value: "",
					active: true
				},
				validationData: {
					code: "",
					name: "",
					category: "",
					discount_type: "",
					discount_value: "",
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				discountStoreAction: 'discountStoreAction',
			}),
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('code', this.discountRequest.code);
				formData.append('name', this.discountRequest.name);
				formData.append('category', this.discountRequest.category);
				formData.append('discount_type', this.discountRequest.discount_type);
				formData.append('discount_value', this.discountRequest.discount_value);
				formData.append('is_active', this.discountRequest.active ? 1 : 0);

				await this.discountStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'discount-list', 
					query: {
						page: 1, 
						per_page: 20, 
						sort_direction: 'desc', 
						sort_by: 'created_at',
						search: '',
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				// Code
				if (this.discountRequest.code == "") {
					this.validationData.code = "The code field is required."
					isValidation.push(true)
				} else {
					this.validationData.code = ""
					isValidation.push(false)
				}
				if (this.discountRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.discountRequest.category == "") {
					this.validationData.category = "The category field is required."
					isValidation.push(true)
				} else {
					this.validationData.category = ""
					isValidation.push(false)
				}
				if (this.discountRequest.discount_type == "") {
					this.validationData.discount_type = "The discount type field is required."
					isValidation.push(true)
				} else {
					this.validationData.discount_type = ""
					isValidation.push(false)
				}
				if (this.discountRequest.discount_value == "" || this.discountRequest.discount_value <= 0) {
					this.validationData.discount_value = "The value field is required and must be greater than zero."
					isValidation.push(true)
				} else {
					this.validationData.discount_value = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>